import { ArmyView } from '@Selectors/builder/myBuilder/builder/new/view/ArmyView';
import { VersionGameView } from '@Selectors/common/view/VersionGameView';

export class ModelRuleSearchView {
  versions: Array<VersionGameView>;
  armies: Array<ArmyView>;
  isLoading: boolean;
  canSubmit: boolean;

  constructor(params: ArmyListNewViewParams) {
    this.versions = params.versions;
    this.armies = params.armies;
    this.isLoading = params.isLoading;
    this.canSubmit = params.canSubmit;
  }
}

export type ArmyListNewViewParams = {
  versions: Array<VersionGameView>;
  armies: Array<ArmyView>;
  isLoading: boolean;
  canSubmit: boolean;
};
